import React, { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import CTA from 'Src/components/buttons/CTA';
import Copy from 'Src/components/Copy';
import { Flex } from 'Src/components/layout/Flex';
import { CardReaderDetails } from 'Src/feature/card-reader/CardReaderDetails';
import { useCardReader } from 'Src/feature/card-reader/useCardReader';
import { buildKeyFromObject } from 'Src/utils/object';

const sectionId = 'SettingsCardReader';
import styles from './SettingsCardReader.module.scss';

const SettingsCardReader: FC<React.PropsWithChildren> = () => {
  const { t } = useTranslation();

  const cardReader = useCardReader();

  const configure = async () => {
    console.warn(sectionId, 'TODO: configure');
  };

  const pairNew = async () => {
    await cardReader.connect({ allowPopup: true });
  };

  return (
    <Flex data-testid={sectionId} className={styles.root}>
      {!cardReader.state.isConnected ? (
        <Flex horizontal justifyContent="space-between">
          <Copy color="textPrimary" variant="h6" value={<Trans i18nKey="settings.info.noCardReaderConnected" />} />
          <CTA color="primary" onClick={pairNew} label={t('settings.labels.noCardReaderButton')} />
        </Flex>
      ) : (
        <Copy
          color="textPrimary"
          variant="h6"
          value={(
            <Trans
              i18nKey="settings.info.configureCardReader"
              values={{ cardReaderModel: cardReader.state.connectedReader?.model }}
            />
          )}
        />
      )}

      {cardReader.state.readers.map((reader) => (
        <CardReaderDetails
          variant="hasBackground"
          key={buildKeyFromObject('card-reader', reader)}
          display={['model', 'connectedIcon', 'serial', 'batteryPercent', 'batteryIcon', 'children-align-right']}
          reader={reader}
        >
          <CTA color="primary" onClick={configure} label={t('labels.configure')} />
        </CardReaderDetails>
      ))}
    </Flex>
  );
};

export default SettingsCardReader;
export { sectionId };
